import { Box, HStack, Text } from '@chakra-ui/react'
import { FC } from 'react'
import { SplashPhase } from './SplashScreen'

const LEO_LOGO = '/transferir.jpeg'

interface Props {
  splashPhase: SplashPhase
}

const ExternoHeader: FC<Props> = ({ splashPhase }) => (
  <Box
    bg="white"
    borderBottom="1px solid"
    borderColor="gray.200"
    px={{ base: 5, md: 10 }}
    h="64px"
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    position="sticky"
    top={0}
    zIndex={10}
  >
    <HStack spacing={2}>
      <Box
        w="32px"
        h="32px"
        flexShrink={0}
        opacity={splashPhase === 'done' ? 1 : 0}
        transition="opacity 0.35s ease"
      >
        <img
          src={LEO_LOGO}
          alt="Leo Madeiras"
          style={{
            width: 32,
            height: 32,
            objectFit: 'contain',
            borderRadius: 6
          }}
        />
      </Box>
      <Text
        fontWeight="800"
        fontSize="17px"
        color="#0f5238"
        letterSpacing="-0.3px"
      >
        Leo Madeiras
      </Text>
      <Text fontWeight="400" fontSize="17px" color="gray.400">
        |
      </Text>
      <Text fontWeight="700" fontSize="17px" color="gray.700">
        SCL
      </Text>
    </HStack>
  </Box>
)

export default ExternoHeader
